import { useAuth as useOidcAuth } from "react-oidc-context";

export const useAuth = () => {
  const auth = useOidcAuth();
  return auth;
};
